'use strict';
import angular from 'angular';

angular.module('products.services', [])
    .service('ProductService', ProductService)
    .service('ProductFactory', ProductFactory);

ProductService.$inject = ['ProductFactory', '$q', 'Upload', 'AppConfig', '$http'];

function ProductService(ProductFactory, $q, Upload, AppConfig, $http) {
    var service = {};
    service.productId = null;
    service.products = null;
    service.product = null;
    service.selectedAccount = '';
    service.facebookAccount = [];
    service.googleAdsAccount = [];
    service.productFields = null;
    service.productFieldGroups = null;
    service.lookupAttributes = null;
    service.lookupContents = null;
    service.lookupTypes = null;
    service.lookupTypesForProduct = null;
    service.dfpKeysList = null;
    service.packages = null;
    service.intrestsContentList = null;
    service.behaviourContentList = null;
    service.demographicsContentList = null;
    service.companyContentList = null;
    service.jobExperienceContentList = null;
    service.jobTitleContentList = null;
    service.degreeContentList = null;
    service.fieldsOfStudyContentList = null;
    service.companyIndustryContentList = null;
    service.trackedConversionCount = null;

    // Get all products for a cluster
    service.getAllProducts = function(showAll) {
        var deferred = $q.defer();
        var params = {};
        if (typeof showAll !== 'undefined' && showAll == 'no') {
            params.showAll = 'no';
        }
        ProductFactory.productsAll().get(params).$promise.then(function(data) {
            service.products = data.products;
            deferred.resolve(data.products);
        }, function(response) {
            console.log("error getting products");
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get facebook account list
    service.getFacebookAccountList = function (param) {
        var deferred = $q.defer();
        ProductFactory.getFacebookAccount().get(param).$promise.then(function (data) {
            service.facebookAccount = data;
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting facebook account data");
            deferred.reject();
        });
        return deferred.promise;
    };
    service.assignExistingCustomer = function(param) {
        let deferred = $q.defer();
        ProductFactory.assignExistingCustomer().save(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getGoogleAdsAccountList = function (param) {
        const cacheKey = 'googleAdsAccountList';
        const now = new Date().getTime();

        let cachedData = JSON.parse(localStorage.getItem(cacheKey));

        if (cachedData && now - cachedData.timestamp < 3600000) {
            return $q.resolve(cachedData.data);
        }

        return ProductFactory.getGoogleAdsAccount().get(param).$promise.then(function (data) {
            localStorage.setItem(cacheKey, JSON.stringify({ data: data, timestamp: now }));
            return data;
        }, function (response) {
            console.log("Error getting Google Ads account data");
            return $q.reject();
        });
    };


    // Get all Packages for a cluster and product
     service.getPackages = function(productId, clusterId) {
        var deferred = $q.defer();
        var params = {};
        params.clusterId = clusterId;
        params.productId = productId;

        ProductFactory.packages().get(params).$promise.then(function(data) {
            service.packages = data.productPackages;
            deferred.resolve();
        }, function(response) {
            console.log("error getting packages");
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get all products for a cluster
    service.getProducts = function(clusterId, showAll) {
        var deferred = $q.defer();
        var params = {};
        if (clusterId) {
            params.clusterId = clusterId;
        }

        if (showAll) {
            params.showAll = 'yes';
        } else {
            params.showAll = 'no';
        }

        ProductFactory.products().get(params).$promise.then(function(data) {
            service.products = data.products;
            deferred.resolve();
        }, function(response) {
            console.log("error getting products");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getProduct = function(productId) {
        var deferred = $q.defer();
        var params = { 'id': productId };

        ProductFactory.product().get(params).$promise.then(function(data) {
            service.product = data.product;
            deferred.resolve();
        }, function(response) {
            console.log("error getting product");
            deferred.reject();
        });

        return deferred.promise;
    };

    //Save Products for a cluster
    service.saveProduct = function(productObj) {
        var deferred = $q.defer();
        var params = productObj;

        ProductFactory.product().post(params).$promise.then(function(data) {
            if (data && data.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data);
            }
        }, function(response) {
            console.log("error saving products");
            deferred.reject();
        });

        return deferred.promise;
    };

    //Save Products for a cluster
    service.updateProduct = function(productObj) {
        var deferred = $q.defer();
        var params = productObj;

        ProductFactory.product().update(params).$promise.then(function(data) {
            if (data && data.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data);
            }
        }, function(response) {
            console.log("error updating products");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    // Get all fields for a single product
    service.getProductFields = function(reqObj) {
        var deferred = $q.defer();
        var params = {
            'productId': reqObj.productId
        };

        if(reqObj.clusterId) {
            params.clusterId = reqObj.clusterId
        }

        if (reqObj.addLookupContent) {
            params.lookup = '1';
        }

        if(reqObj.clientId) {
            params.clientId = reqObj.clientId
        }

        if(reqObj.packageId) {
            params.packageId = reqObj.packageId;
        }

        ProductFactory.productFields().get(params).$promise.then(function(data) {
            service.productFields = data.productFields;
            deferred.resolve(data.productName);
        }, function(response) {
            console.log("error getting product fields");
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get all keys list for a single product
    service.getProductDfpKeys = function(clientId, clusterId, productId, lookup) {
        var deferred = $q.defer();

        var params = {
            'clientId': clientId,
            'clusterId': clusterId,
            'productId': productId,
            'lookup': lookup
        };
        ProductFactory.productFields().get(params).$promise.then(function(data) {
            service.dfpKeysList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting product fields");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getProductFieldsForDisplay = function(productId, showAll = false) {
        var deferred = $q.defer();
        var params = {
            'productId': productId,
        };

        if (showAll) {
            params.showAll = true;
        }

        ProductFactory.productFields().get(params).$promise.then(function(data) {
            service.productFields = data.productFields;
            deferred.resolve(data.productName);
        }, function(response) {
            console.log("error getting product fields");
            deferred.reject();
        });

        return deferred.promise;
    };

    // Save a new Product Field
    service.saveProductField = function(filedsObj) {
        var deferred = $q.defer();
        var params = filedsObj;

        ProductFactory.productField().post(params).$promise.then(function(data) {
            if(data.productField){
                deferred.resolve(data.productField);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error saving product field");
            deferred.reject();
        });

        return deferred.promise;
    };

    // Update an existing Product Fields
    service.updateProductField = function(filedsObj) {
        var deferred = $q.defer();
        var params = filedsObj;

        ProductFactory.productField().update(params).$promise.then(function(data) {
            if (data.productField) {
                deferred.resolve(data.productField);
            } else {
                deferred.reject(data);
            }
        }, function(response) {
            console.log("error updating product field");
            deferred.reject();
        });

        return deferred.promise;
    };

    //update product fields display order
    service.updateProductDisplayOrder = function(params) {
        var deferred = $q.defer();
        var fields = {fields: params};

        ProductFactory.productFieldDisplayOrder().post(fields).$promise.then(function(data) {
            if(data.productFields){
                deferred.resolve(data.productFields);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error updating product field display order");
            deferred.reject();
        });

        return deferred.promise;
    }


    // Get all field groups for a single product
    service.getProductFieldGroups = function(productId) {
        var deferred = $q.defer();
        var params = {
            'productId': productId
        };

        ProductFactory.productFieldGroups().get(params).$promise.then(function(data) {
            service.productFieldGroups = data.productFieldGroups;
            deferred.resolve();
        }, function(response) {
            console.log("error getting product field groups");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getProductFieldGroupsForDisplay = function(productId) {
        var deferred = $q.defer();
        var params = {
            'productId': productId,
            'showAll': true
        };

        ProductFactory.productFieldGroups().get(params).$promise.then(function(data) {
            service.productFieldGroups = data.productFieldGroups;
            deferred.resolve();
        }, function(response) {
            console.log("error getting product field groups");
            deferred.reject();
        });

        return deferred.promise;
    };

    //Save Product Fields
    service.saveProductGroups = function(groupsObj) {
        let deferred = $q.defer();
        let params = groupsObj;

        ProductFactory.productFieldGroup().post(params).$promise.then(function(data) {
            if (data?.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data?.productFieldGroup);
            }
        }, function(response) {
            deferred.reject(response);
        });

        return deferred.promise;
    };
    service.updateProductGroups = function(groupsObj) {
        let deferred = $q.defer();
        let params = groupsObj;

        ProductFactory.productFieldGroup().update(params).$promise.then(function(data) {
            data ? deferred.resolve(data) : deferred.reject();
        }, function(response) {
            console.log("error updating product groups");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteProductGroup = function(groupId) {
        var deferred = $q.defer();

        ProductFactory.productFieldGroup().delete({
            'id': groupId
        }).$promise.then(function(data) {
            deferred.resolve(data.productFieldGroup);
        }, function(response) {
            console.log("error deleting product group");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addProductContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.lookupTypes().save({
            'types': 'addProductContents'
        }, params).$promise.then(function(data) {
            deferred.resolve(data.productLookupContents);
        }, function(response) {
            console.log("error getting lookup attributes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateProductContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.lookupTypes().update({
            'types': 'updateProductContents'
        }, params).$promise.then(function(data) {
            deferred.resolve(data.productLookupContents);
        }, function(response) {
            console.log("error getting lookup attributes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteProductContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.lookupTypes().delete({
            'types': 'deleteProductLookupContents',
            'productId': params.productId,
            'clusterId': params.clusterId,
            'lookupTypeId': params.lookupTypeId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting lookup attributes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getProductContents = function(productId, clusterId, lookupTypeId) {
        var deferred = $q.defer();
        ProductFactory.lookupTypes().get({
            'types': 'productLookupTypeContents',
            'productId': productId,
            'clusterId': clusterId,
            'lookupTypeId': lookupTypeId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting lookup attributes");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getLookupTypes = function() {
        var deferred = $q.defer();

        ProductFactory.lookupTypes().get({
            'types': 'types'
        }).$promise.then(function(data) {
            service.lookupTypes = data.lookupTypes;
            deferred.resolve();
        }, function(response) {
            console.log("error getting lookup types");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getLookupTypesForProduct = function(productId) {
        var deferred = $q.defer();

        ProductFactory.lookupTypes().get({
            'types': 'typesForProduct',
            'productId': productId
        }).$promise.then(function(data) {
            service.lookupTypesForProduct = data.lookupTypes;
            deferred.resolve();
        }, function(response) {
            console.log("error getting lookup types");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.saveLookupType = function(params) {
        var deferred = $q.defer();

        ProductFactory.lookupTypes().save({
            'types': 'type'
        }, params).$promise.then(function(data) {
            deferred.resolve(data.lookupType);
        }, function(response) {
            console.log("error saving lookup type");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.updateLookupType = function(params) {
        var deferred = $q.defer();

        ProductFactory.lookupTypes().update({
            'types': 'type'
        }, params).$promise.then(function(data) {
            deferred.resolve(data.lookupType);
        }, function(response) {
            console.log("error updating lookup type");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.deleteLookupType = function(lookupTypeId) {
        var deferred = $q.defer();

        ProductFactory.lookupTypes().delete({
            'types': 'type',
            'id': lookupTypeId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting lookup type " + response.data.id);
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getLookupContentKeys = function() {
        var deferred = $q.defer();

        ProductFactory.lookupContentKeys().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting lookup contents");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getDevicesByContentKey = function(param) {
        var deferred = $q.defer();
        ProductFactory.devicesContents().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting "+ param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getAdunitsByContentKey = function(param) {
        var deferred = $q.defer();
        ProductFactory.getAdUnitsContents().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting "+ param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.searchAdunitsByInput = function (param) {
        var deferred = $q.defer();
        ProductFactory.searchByInput().get(param).$promise.then(function (data) {
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting " + param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTrackedConversions = function (params) {
        var deferred = $q.defer();
        ProductFactory.getTrackedConversionsCount().get(params).$promise.then(function (data) {
            service.trackedConversionCount = data.trackedConversions;
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting tracked conversions");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getRoasStrategies = function (param) {
        var deferred = $q.defer();
        ProductFactory.getAllRoasStrategies().get(param).$promise.then(function (data) {
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting " + param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getCpaStrategies = function (param) {
        var deferred = $q.defer();
        ProductFactory.getAllCpaStrategies().get(param).$promise.then(function (data) {
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting " + param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getInMarketValuesByParent = function(param) {
        var deferred = $q.defer();
        ProductFactory.inMarketValues().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting inmarkets list");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getCustomAudienceValues = function(param) {
        var deferred = $q.defer();
        ProductFactory.customAudienceValues().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting custom audience list");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getCombinedAudienceValues = function(param) {
        var deferred = $q.defer();
        ProductFactory.combinedAudienceValues().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting combined audience list");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getReMarketListValues = function (param) {
        var deferred = $q.defer();
        ProductFactory.reMarketValues().get(param).$promise.then(function (data) {
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting remarkets list");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getMobileAppsByContentKey = function(param) {
        var deferred = $q.defer();
        ProductFactory.mobileAppsContents().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting "+ param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getDeviceCapabilitiesByContentKey = function(param) {
        var deferred = $q.defer();
        ProductFactory.deviceCapabilities().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting "+ param.contentKey + " list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLookupContent = function(lookupTypeId, clusterId = 0) {
        var deferred = $q.defer();

        ProductFactory.lookupContents().get({
            'contents': 'contents',
            'lookupTypeId': lookupTypeId,
            'clusterId': clusterId
        }).$promise.then(function(data) {
            service.lookupContents = data.lookupContents;
            deferred.resolve();
        }, function(response) {
            console.log("error getting lookup contents");
            deferred.reject(response);
        });

        return deferred.promise;
    };
    service.getUpdatelookupContents = function(lookupTypeId,clusterId){
        var deferred = $q.defer();

        ProductFactory.getupdatedlookupContents(lookupTypeId,clusterId).get().$promise.then(function(data) {
            service.lookupContents = data.lookupContents;
            deferred.resolve();
        }, function(response) {
            console.log("error getting Update lookup contents");
            deferred.reject(response);
        });

        return deferred.promise;
    }

    service.saveLookupContent = function(lookupId, params) {
        var deferred = $q.defer();
        ProductFactory.lookupContents().save({
            'contents': 'content',
            'lookupTypeId': lookupId
        }, params).$promise.then(function(data) {
            deferred.resolve(data.lookupContent);
        }, function(response) {
            console.log("error saving lookup content");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.updateLookupContent = function(lookupId, params) {
        var deferred = $q.defer();

        ProductFactory.lookupContents().update({
            'contents': 'content',
            'lookupTypeId': lookupId
        }, params).$promise.then(function(data) {
            deferred.resolve(data.lookupContent);
        }, function(response) {
            console.log("error updating lookup content");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.deleteLookupContent = function(lookupContentId) {
        var deferred = $q.defer();
        ProductFactory.lookupContents().delete({
            'contents': 'content',
            'id': lookupContentId
        }).$promise.then(function(data) {
            deferred.resolve();
        }, function(response) {
            console.log("error getting lookup contents");
            deferred.reject(response);
        });
        return deferred.promise;
    };

    service.cloneProduct = function(productId, productName) {
        var deferred = $q.defer();
        var params = {
            'id': productId,
            'name': productName
        };

        ProductFactory.clone().save(params).$promise.then(function(data) {
            if (data.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve();
            }
        }, function(response) {
            console.log("error cloning product");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.cloneProductLookupContent = function(sourceClusterId, destClusterIds, sourceProductId, destProductIds, lookupTypeIds) {
        var deferred = $q.defer();
        var params = {
            'sourceClusterId': sourceClusterId,
            'destClusterIds': destClusterIds,
            'sourceProductId': sourceProductId,
            'destProductIds': destProductIds,
            'lookupTypeIds': lookupTypeIds
        };

        ProductFactory.cloneLookupContent().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error cloning product lookup content");
            deferred.reject();
        });

        return deferred.promise;
    };

    //clone all product lookup content for clusters
    service.cloneAllProductLookupContentForClusters = function(sourceClusterId, destClusterIds) {
        var deferred = $q.defer();
        var params = {
            'sourceClusterId': sourceClusterId,
            'destClusterIds': destClusterIds
        };

        ProductFactory.cloneAllProductLookupContentForClusters().save(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error cloning all product lookup content");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getExistingProductLists = function(getProductList,merchantId){
        var deferred = $q.defer();
        ProductFactory.ExistingProductList(getProductList,merchantId).get().$promise.then(function(data) {
            deferred.resolve(data.values);
        }, function(response) {
            console.log("error getting existing products list");
            deferred.reject(response);
        });
        return deferred.promise;
    };

    /*
    * GET TA services
    */
    service.getTAServices = function() {
        var deferred = $q.defer();

        ProductFactory.TAServices().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting TA services");
            deferred.reject();
        });

        return deferred.promise;
    };

    /*
     * Form Template services need to move to a new module
     */

    service.getTemplateTypes = function() {
        var deferred = $q.defer();

        ProductFactory.formTemplates().get({ 'type': 'formTypes' }).$promise.then(function(data) {
            deferred.resolve(data.template_types);
        }, function(response) {
            console.log("error getting form templateTypes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTemplates = function(id) {
        var deferred = $q.defer();

        ProductFactory.formTemplates().get({ 'typeId': id }).$promise.then(function(data) {
            deferred.resolve(data.templates);
        }, function(response) {
            console.log("error getting form templateTypes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getClustersWithoutOrderForm = function() {
        var deferred = $q.defer();

        ProductFactory.formTemplates().get({ 'type': 'clustersWithoutOrderForm' }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting Clusters Without Order Form");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.recalculateAll = function(productFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': productFieldId
        };

        ProductFactory.recalculateAll().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error recalculating product field attributes");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.lineItemIdsUsingProductField = function(productFieldId) {
        let deferred = $q.defer();
        let params = {
            'id': productFieldId
        };

        ProductFactory.lineItemIdsUsingProductField().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error getting list of line item ids using product field id " + productFieldId);
            deferred.reject(response);
        });

        return deferred.promise;
    }

    service.saveFormEntity = function(obj) {
        var deferred = $q.defer();

        ProductFactory.formEntity().save(obj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting form templateTypes");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.importLookup = function(customFile) {
        var deferred = $q.defer();

        Upload.upload({
            url: AppConfig.IO_API_URL + 'lookups/importLookups',
            file: customFile
        }).success(function(data, status, headers, config) {
            if (data.result){
                deferred.resolve(data.result);
            }else{
                deferred.reject();
            }
        }).error(function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.exportLookup = function() {
        var deferred = $q.defer();

        $http.get(AppConfig.IO_API_URL + 'lookups/exportLookups').then(function(response) {
            deferred.resolve(response);
        }, function(error){
            deferred.reject();
        });
        /*ProductFactory.lookupTypes().get({'types': 'exportLookups'}).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting form templateTypes");
            deferred.reject();
        });*/

        return deferred.promise;
    };

    service.exportProduct = function(productId) {
        var deferred = $q.defer();

        $http.get(AppConfig.IO_API_URL + 'products/export', {
            params: {'id': productId}}).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            console.log("error exporting product");
            deferred.reject(error);
        });

        return deferred.promise;
    };

    service.importProduct = function(customFile) {
        var deferred = $q.defer();

        Upload.upload({
            url: AppConfig.IO_API_URL + 'products/import',
            file: customFile
        }).success(function(data, status, headers, config) {
            if (data.result){
                deferred.resolve(data.result);
            }else{
                deferred.reject(data.errors);
            }
        }).error(function(error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    service.getSnapGenderContents = function (params) {
        var deferred = $q.defer();
        ProductFactory.getSnapGenderData().get(params).$promise.then(function (data) {
            service.snapGenderContentList = data;
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting snap chat gender data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getAdvancedDemographicsContents = function (params) {
        var deferred = $q.defer();
        ProductFactory.getAdvancedDemographicsData().get(params).$promise.then(function (data) {
            service.demographicsContentList = data;
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting demographics data");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getIntrestsContent = function(params) {
        var deferred = $q.defer();
        ProductFactory.getIntrestsData().get(params).$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting intrests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getInterestsContentForPinterest = function() {
        var deferred = $q.defer();
        ProductFactory.getPinterestIntrestsData().get().$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getInterestsContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokIntrestsData().get(params).$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getHashtagInteractionsContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getHashtagInteractionsData().get(params).$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getVideoInteractionsContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getVideoInteractionsData().get(params).$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getCreatorInteractionsContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getCreatorInteractionsData().get(params).$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getDevicesContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokDevicesData().get(params).$promise.then(function(data) {
            service.devicesContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting devices data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getCarriersContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokCarriersData().get(params).$promise.then(function(data) {
            service.carriersContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting carriers data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getIspContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokIspData().get(params).$promise.then(function(data) {

            // Assign received data to service variable
            service.ispContentList = data;
            // Resolving the promise with received data
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting isp data");
            // Rejecting the promise on error
            deferred.reject();
        });

        return deferred.promise;
    };


    service.getInterestsContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinIntrestsData(params).get().$promise.then(function(data) {
            service.intrestsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting interests data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getDemographicsContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinDemographicsData(params).get().$promise.then(function(data) {
            service.demographicsContentList= data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting demographics data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getCompanyContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinCompanyData(params).get().$promise.then(function(data) {
            service.companyContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting company data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getFieldsOfStudyContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinFieldsOfStudyData(params).get().$promise.then(function(data) {
            service.fieldsOfStudyContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting fieldsOfStudy data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getJobExperienceContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinJobExperienceData(params).get().$promise.then(function(data) {
            service.jobExperienceContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting job experience data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getJobTitleContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinJobTitleData(params).get().$promise.then(function(data) {
            service.jobTitleContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting titles data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getCompanyIndustryContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinCompanyIndustryData(params).get().$promise.then(function(data) {
            service.companyIndustryContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting industries data");
            deferred.reject();
        });

        return deferred.promise;
    };
    service.getDegreeContentForLinkedin = function(params) {
        var deferred = $q.defer();
        ProductFactory.getLinkedinDegreeData(params).get().$promise.then(function (data) {
            service.degreeContentList = data;
            deferred.resolve(data);
        }, function (response) {
            console.log("error getting degrees data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTritonTeamContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTritonTeamsData().get(params).$promise.then(function(data) {
            service.tritonTeamsList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting teams list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getYelpCategoryContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.getYelpCategoriesData().get(params).$promise.then(function(data) {
            service.yelpCategoriesList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting categories list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBehavioursContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.getBehavioursData().get(params).$promise.then(function(data) {
            service.behaviourContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting behaviour data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBehavioursContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.getBehavioursData().get(params).$promise.then(function(data) {
            service.demographicsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting demographics data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getDemographicsContents = function(params) {
        var deferred = $q.defer();
        ProductFactory.getDemographicsData().get(params).$promise.then(function(data) {
            service.demographicsContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting behaviour data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSnapLifestylesContent = function(params) {
        var deferred = $q.defer();
        ProductFactory.getSnapLifestylesData().get(params).$promise.then(function(data) {
            service.lifestylesContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting snap lifestyle data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTiktokOsVersionContent = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokOsVersionData().get(params).$promise.then(function(data) {
            service.tiktokOsVersionList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting snap lifestyle data");
            deferred.reject();
        });

        return deferred.promise;
    }

    service.getLanguagesContentForTiktok = function(params) {
        var deferred = $q.defer();
        ProductFactory.getTiktokLanguagesData().get(params).$promise.then(function(data) {
            service.languagesContentList = data;
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting languages data");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getFacebookAudiences = function(param) {
        var deferred = $q.defer();
        ProductFactory.facebookAudiences().get(param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting facebook audiences list");
            deferred.reject();
        });

        return deferred.promise;
    };

    return service;
}

ProductFactory.$inject = ['$resource', 'AppConfig'];

function ProductFactory($resource, AppConfig) {

    var factory = {};

    factory.products = function() {
        return $resource(AppConfig.IO_API_URL + 'products', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getFacebookAccount = function () {
        return $resource(AppConfig.IO_API_URL + 'api/getFacebookAccountList', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.assignExistingCustomer = function() {
        return $resource(AppConfig.IO_API_URL + 'PushIntegration/assigncustomer', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.getGoogleAdsAccount = function () {
        return $resource(AppConfig.IO_API_URL + 'api/getGoogleAdsAccountList', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.productsAll = function() {
        return $resource(AppConfig.IO_API_URL + 'products/all', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.packages = function() {
        return $resource(AppConfig.IO_API_URL + 'productPackage/getProductPackageByProductId', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    }

    factory.product = function() {
        return $resource(AppConfig.IO_API_URL + 'products/product', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'post': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.productFields = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productFields', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.TAServices = function() {
        return $resource(AppConfig.MAGE_URL + 'service/get_services', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.productField = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productField', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'post': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.productFieldDisplayOrder = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productFieldsDisplayOrder', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.productFieldGroups = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productFieldGroups', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.productFieldGroup = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productFieldGroup', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'post': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.productFieldDisplayName = function() {
        return $resource(AppConfig.IO_API_URL + 'products/productFieldDisplayName', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.lookupTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/:types', {
            types: '@types'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    //Associated with lookup id
    factory.lookupContents = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/:contents', {
            contents: '@contents'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'method': {
                method: 'DELETE'
            }
        });
    };

    factory.getupdatedlookupContents = function(lookupTypeId,clusterId){
        return $resource(AppConfig.IO_API_URL + 'lookups/updateLookupContents?clusterId='+clusterId+'&lookupTypeId='+lookupTypeId, null , {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.lookupContentKeys = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contentKeys', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    
    factory.devicesContents = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };
    
    factory.getAdUnitsContents = function() {
        return $resource(AppConfig.API_URL + 'hierarchicaldata', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAdUnitsContents = function() {
        return $resource(AppConfig.API_URL + 'hierarchicaldata', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };


    factory.searchByInput = function () {
        return $resource(AppConfig.API_URL + 'hierarchicaldata/search', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.inMarketValues = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/getInMarketValuesByParent', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.customAudienceValues = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/getCustomAudienceValues', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.combinedAudienceValues = function() {
        return $resource(AppConfig.IO_API_URL + 'lineItems/getCombinedAudienceValues', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTrackedConversionsCount = function() {
        return $resource(AppConfig.IO_API_URL + 'api/trackedConversionsForAdwords', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAllRoasStrategies = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAllCpaStrategies = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.reMarketValues = function () {
        return $resource(AppConfig.IO_API_URL + 'lineItems/getRemarketingListValues', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.mobileAppsContents = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.ExistingProductList = function(getProductList,merchantId) {
        return $resource(AppConfig.IO_API_URL + 'lineItems/ExistingProductList?operation='+getProductList+'&merchant_id='+merchantId, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.deviceCapabilities = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/contents', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.clone = function() {
        return $resource(AppConfig.IO_API_URL + 'products/clone', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.recalculateAll = function() {
        return $resource(AppConfig.IO_API_URL + 'products/recalculateAll', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.lineItemIdsUsingProductField = function() {
        return $resource(AppConfig.IO_API_URL + 'products/lineItemIdsUsingProductField', null, {
            'get': {
                method: 'GET'
            }
        });
    };

    factory.cloneLookupContent = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/cloneProductLookupContentForClustersAndProducts', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.cloneAllProductLookupContentForClusters = function() {
        return $resource(AppConfig.IO_API_URL + 'lookups/cloneProductLookupContentForClusters', null, {
            'post': {
                method: 'POST'
            }
        });
    };

    factory.formTemplates = function() {
        return $resource(AppConfig.IO_API_URL + 'templates/:type', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.formEntity = function() {
        return $resource(AppConfig.IO_API_URL + 'formEntityBuilder', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.getSnapGenderData = function () {
        return $resource(AppConfig.IO_API_URL + 'api/getSnapGender', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAdvancedDemographicsData = function () {
        return $resource(AppConfig.IO_API_URL + 'api/getAdvancedDemographics', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getIntrestsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getInterestsForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBehavioursData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getBehavioursForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getDemographicsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getDemographicsForClient', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getPinterestIntrestsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getPinterestInterests', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokIntrestsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokInterests', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokDevicesData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokDevices', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokCarriersData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokCarriers', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokIspData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokIsp', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getHashtagInteractionsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokHashtagInteractions', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getVideoInteractionsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokInteractions', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getCreatorInteractionsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokInteractions', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinIntrestsData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getLinkedinInterests?client_id='+params.clientId, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTritonTeamsData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTritonTeams', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getYelpCategoriesData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getYelpCategories', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinDemographicsData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getDemographicsAudienceAttributes?client_id='+params.clientId, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinCompanyData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getCompanyAudienceAttributes?client_id='+params.clientId, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinFieldsOfStudyData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getFieldsOfStudyAudienceAttributes?client_id='+params.clientId+'&keyword='+params.keyword, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinJobExperienceData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getJobExperienceAudienceAttributes?client_id='+params.clientId, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinJobTitleData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getJobTitleAudienceAttributes?client_id=' + params.clientId + '&keyword=' + params.keyword, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinDegreeData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getDegreeAudienceAttributes?client_id=' + params.clientId + '&keyword=' + params.keyword, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getLinkedinCompanyIndustryData = function(params) {
        return $resource(AppConfig.IO_API_URL + 'api/getCompanyIndustryAudienceAttributes?client_id=' + params.clientId + '&keyword=' + params.keyword, null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSnapLifestylesData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getSnapLifestyles', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokOsVersionData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokOsVersion', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getTiktokLanguagesData = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getTiktokLanguages', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.facebookAudiences = function() {
        return $resource(AppConfig.IO_API_URL + 'api/getFacebookAudiences', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;
}